import React from "react";
import { Typography } from "@mui/material"
import { Stack } from "@mui/material"
import loginLogo from '../Assets/Cavalier-Upright-Color-Logo.png';
import { useDataContext } from "../Context/useDataContext";


export const LockScreen = () => {

    const { registrationData, scoreCode } = useDataContext();

    return (
        
        <Stack id="score-lock-message" direction={'column'}
            sx={{
                width: '100dvw', 
                height: '100dvh',
                backgroundColor: 'sepia.background',
                overscrollBehavior: 'none',
                overflow: 'hidden',
                position: 'fixed',
                top: 0,
                left: 0,
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Stack direction='column' spacing={2} 
                sx={{width: '90%', height: '70%', justifyContent: 'center', alignItems: 'center',
                backgroundColor: 'sepia.background', border: '1px solid', borderColor: 'sepia.extraLight', borderRadius: 5}}>
                    <Typography variant='h6' sx={{ textAlign: 'center', marginTop: 2 }}>Score Submitted for</Typography>
                    <Typography variant='h6' sx={{ textAlign: 'center' }}> 
                    {registrationData
                        .filter((reg: any) => reg.scoreCode !== scoreCode)
                        .map((player: any) => player.playerName)
                        .join(' and ')
                    } by {
                        registrationData
                        .filter((reg: any) => reg.scoreCode === scoreCode)
                        .map((player: any) => player.playerName)
                        .join(' and ')
                        }
                    </Typography>
                    <Typography variant='h6' sx={{ textAlign: 'center' }}>To view submitted and live scores, please use the standings section..</Typography>
                    <img src={loginLogo} width="200" height="200" style={{marginBottom: 30}} />
                </Stack>
        </Stack>
    )
}
